import { render } from "./EnviromentImpact.vue?vue&type=template&id=00483c58&scoped=true"
import script from "./EnviromentImpact.vue?vue&type=script&lang=js"
export * from "./EnviromentImpact.vue?vue&type=script&lang=js"

import "./EnviromentImpact.vue?vue&type=style&index=0&id=00483c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00483c58"]])

export default __exports__